const filterApiResponce = {
  status: true,
  statusCode: 200,
  data: [
    {
      filterType: "Color",
      displayOrder: 1,
      displayName: "Color",
      displayType: "color",
      list: [
        {
          colorCode: "#000000",
          displayName: "Black",
          value: "Black",
        },
        {
          colorCode: "#0000CC",
          displayName: "Blue",
          value: "Blue",
        },
        {
          colorCode: "#7E3517",
          displayName: "Brown",
          value: "Brown",
        },
        {
          colorCode: "#FFEBCD",
          displayName: "Beige",
          value: "Beige",
        },
        {
          colorCode: "#FFD700",
          displayName: "Gold",
          value: "Gold",
        },
        {
          colorCode: "#008000",
          displayName: "Green",
          value: "Green",
        },
        {
          colorCode: "#808080",
          displayName: "Grey",
          value: "Grey",
        },
        {
          colorCode: "",
          displayName: "Multi-colour",
          value: "Multi-colour",
        },
        {
          colorCode: "#FFA500",
          displayName: "Orange",
          value: "Orange",
        },
        {
          colorCode: "#FF69B4",
          displayName: "Pink",
          value: "Pink",
        },
        {
          colorCode: "#9370DB",
          displayName: "Purple",
          value: "Purple",
        },
        {
          colorCode: "#FF0000",
          displayName: "Red",
          value: "Red",
        },
        {
          colorCode: "#C0C0C0",
          displayName: "Silver",
          value: "Silver",
        },
        {
          colorCode: "#FFFFFF",
          displayName: "White",
          value: "White",
        },
        {
          displayName: "No colour",
          value: "No colour",
        },
        {
          colorCode: "#FFFF00",
          displayName: "Yellow",
          value: "Yellow",
        },
        {
          colorCode: "",
          displayName: "Assorted",
          value: "Assorted",
        },
      ],
    },
    {
      filterType: "Price",
      displayOrder: 2,
      displayName: "Price",
      displayType: "minMaxRange",
      list: [
        {
          min: 0,
          max: 499,
        },
        {
          min: 500,
          max: 999,
        },
        {
          min: 1000,
          max: 1499,
        },
        {
          min: 1500,
          max: 1999,
        },
        {
          min: 2000,
          max: 0,
        },
      ],
    },
    {
      filterType: "Occasion",
      displayOrder: 3,
      displayName: "Occasion",
      displayType: "default",
      list: [
        {
          displayName: "Weekend",
          value: "Weekend",
          subOccasions: ["Casual"],
        },
        {
          displayName: "Work",
          value: "Work",
          subOccasions: ["Work", "Smart casual"],
        },
        {
          displayName: "Party",
          value: "Party",
          subOccasions: ["Party"],
        },
        {
          displayName: "Gym",
          value: "Gym",
          subOccasions: ["Gymming", "Yoga", "Sport", "Running", "Training"],
        },
        {
          displayName: "Outdoor",
          value: "Outdoor",
          subOccasions: ["Outdoors", "Outdoor"],
        },
      ],
    },
    {
      filterType: "Brand",
      displayOrder: 4,
      displayName: "Brand",
      displayType: "default",
      list: [
        {
          displayName: "AZZARO",
          value: "AZZARO",
          legalBrandNames: ["AZZARO"],
        },
        {
          displayName: "Aeropostale",
          value: "Aeropostale",
          legalBrandNames: ["Aeropostale"],
        },
        {
          displayName: "Anahi",
          value: "Anahi",
          legalBrandNames: ["Anahi"],
        },
        {
          displayName: "Arrow",
          value: "Arrow",
          legalBrandNames: ["Arrow"],
        },
        {
          displayName: "Arrow Blue Jeans Company",
          value: "Arrow Blue Jeans Company",
          legalBrandNames: ["Arrow Blue Jeans Company"],
        },
        {
          displayName: "Arrow Newyork",
          value: "Arrow Newyork",
          legalBrandNames: ["Arrow Newyork"],
        },
        {
          displayName: "Arrow Sports",
          value: "Arrow Sports",
          legalBrandNames: ["Arrow Sports"],
        },
        {
          displayName: "Arrow Woman",
          value: "Arrow Woman",
          legalBrandNames: ["Arrow Woman"],
        },
        {
          displayName: "BECCA",
          value: "BECCA",
          legalBrandNames: ["BECCA"],
        },
        {
          displayName: "BURT'S BEES",
          value: "BURT'S BEES",
          legalBrandNames: ["BURT'S BEES"],
        },
        {
          displayName: "BVLGARI",
          value: "BVLGARI",
          legalBrandNames: ["BVLGARI"],
        },
        {
          displayName: "Bayisland",
          value: "Bayisland",
          legalBrandNames: ["Bayisland"],
        },
        {
          displayName: "Benefit Cosmetics",
          value: "Benefit Cosmetics",
          legalBrandNames: ["Benefit Cosmetics"],
        },
        {
          displayName: "Bronz",
          value: "Bronz",
          legalBrandNames: ["Bronz"],
        },
        {
          displayName: "CK Fragrances",
          value: "CK Fragrances",
          legalBrandNames: ["CK Fragrances"],
        },
        {
          displayName: "CLINIQUE",
          value: "CLINIQUE",
          legalBrandNames: ["CLINIQUE"],
        },
        {
          displayName: "COVER FX",
          value: "COVER FX",
          legalBrandNames: ["COVER FX"],
        },
        {
          displayName: "Carolina Herrera",
          value: "Carolina Herrera",
          legalBrandNames: ["Carolina Herrera"],
        },
        {
          displayName: "Cherokee",
          value: "Cherokee",
          legalBrandNames: ["Cherokee"],
        },
        {
          displayName: "Chloe",
          value: "Chloe",
          legalBrandNames: ["Chloe"],
        },
        {
          displayName: "Colt",
          value: "Colt",
          legalBrandNames: ["Colt"],
        },
        {
          displayName: "DAVIDOFF",
          value: "DAVIDOFF",
          legalBrandNames: ["DAVIDOFF"],
        },
        {
          displayName: "DIESEL",
          value: "DIESEL",
          legalBrandNames: ["DIESEL"],
        },
        {
          displayName: "Day 2 Day",
          value: "Day 2 Day",
          legalBrandNames: ["Day 2 Day"],
        },
        {
          displayName: "Donuts",
          value: "Donuts",
          legalBrandNames: ["Donuts"],
        },
        {
          displayName: "ELIE SAAB",
          value: "ELIE SAAB",
          legalBrandNames: ["ELIE SAAB"],
        },
        {
          displayName: "Ed Hardy",
          value: "Ed Hardy",
          legalBrandNames: ["Ed Hardy"],
        },
        {
          displayName: "EdHardy Women",
          value: "EdHardy Women",
          legalBrandNames: ["EdHardy Women"],
        },
        {
          displayName: "Elitus",
          value: "Elitus",
          legalBrandNames: ["Elitus"],
        },
        {
          displayName: "Elizabeth Arden",
          value: "Elizabeth Arden",
          legalBrandNames: ["Elizabeth Arden"],
        },
        {
          displayName: "Elle",
          value: "Elle",
          legalBrandNames: ["Elle"],
        },
        {
          displayName: "Elle Kids",
          value: "Elle Kids",
          legalBrandNames: ["Elle Kids"],
        },
        {
          displayName: "Estee Lauder",
          value: "Estee Lauder",
          legalBrandNames: ["Estee Lauder"],
        },
        {
          displayName: "Excalibur",
          value: "Excalibur",
          legalBrandNames: ["Excalibur"],
        },
        {
          displayName: "FM Boys",
          value: "FM Boys",
          legalBrandNames: ["FM Boys"],
        },
        {
          displayName: "FOREO",
          value: "FOREO",
          legalBrandNames: ["FOREO"],
        },
        {
          displayName: "FOREST ESSENTIALS",
          value: "FOREST ESSENTIALS",
          legalBrandNames: ["FOREST ESSENTIALS"],
        },
        {
          displayName: "Flying Machine",
          value: "Flying Machine",
          legalBrandNames: ["Flying Machine"],
        },
        {
          displayName: "Flying Machine Women",
          value: "Flying Machine Women",
          legalBrandNames: ["Flying Machine Women"],
        },
        {
          displayName: "GAP",
          value: "GAP",
          legalBrandNames: ["GAP"],
        },
        {
          displayName: "GIORGIO ARMANI",
          value: "GIORGIO ARMANI",
          legalBrandNames: ["GIORGIO ARMANI"],
        },
        {
          displayName: "Gant",
          value: "Gant",
          legalBrandNames: ["Gant"],
        },
        {
          displayName: "Givenchy",
          value: "Givenchy",
          legalBrandNames: ["Givenchy"],
        },
        {
          displayName: "Issey Miyake",
          value: "Issey Miyake",
          legalBrandNames: ["Issey Miyake"],
        },
        {
          displayName: "Izod",
          value: "Izod",
          legalBrandNames: ["Izod"],
        },
        {
          displayName: "Karigari",
          value: "Karigari",
          legalBrandNames: ["Karigari"],
        },
        {
          displayName: "Kenzo",
          value: "Kenzo",
          legalBrandNames: ["Kenzo"],
        },
        {
          displayName: "Levi's",
          value: "Levi's",
          legalBrandNames: ["Levi's"],
        },
        {
          displayName: "MAKE UP FOR EVER",
          value: "MAKE UP FOR EVER",
          legalBrandNames: ["MAKE UP FOR EVER"],
        },
        {
          displayName: "MARC JACOBS",
          value: "MARC JACOBS",
          legalBrandNames: ["MARC JACOBS"],
        },
        {
          displayName: "MONTBLANC",
          value: "MONTBLANC",
          legalBrandNames: ["MONTBLANC"],
        },
        {
          displayName: "MOSCHINO",
          value: "MOSCHINO",
          legalBrandNames: ["MOSCHINO"],
        },
        {
          displayName: "MUGLER",
          value: "MUGLER",
          legalBrandNames: ["MUGLER"],
        },
        {
          displayName: "NATIO",
          value: "NATIO",
          legalBrandNames: ["NATIO"],
        },
        {
          displayName: "NINA RICCI",
          value: "NINA RICCI",
          legalBrandNames: ["NINA RICCI"],
        },
        {
          displayName: "Narciso Rodriguez",
          value: "Narciso Rodriguez",
          legalBrandNames: ["Narciso Rodriguez"],
        },
        {
          displayName: "Nautica",
          value: "Nautica",
          legalBrandNames: ["Nautica"],
        },
        {
          displayName: "Nautica Kids",
          value: "Nautica Kids",
          legalBrandNames: ["Nautica Kids"],
        },
        {
          displayName: "Newport",
          value: "Newport",
          legalBrandNames: ["Newport"],
        },
        {
          displayName: "O.P.I",
          value: "O.P.I",
          legalBrandNames: ["O.P.I"],
        },
        {
          displayName: "Oscar Blandi",
          value: "Oscar Blandi",
          legalBrandNames: ["Oscar Blandi"],
        },
        {
          displayName: "PERCY & REED",
          value: "PERCY & REED",
          legalBrandNames: ["PERCY & REED"],
        },
        {
          displayName: "PRADA",
          value: "PRADA",
          legalBrandNames: ["PRADA"],
        },
        {
          displayName: "Paco Rabanne",
          value: "Paco Rabanne",
          legalBrandNames: ["Paco Rabanne"],
        },
        {
          displayName: "RALPH LAUREN",
          value: "RALPH LAUREN",
          legalBrandNames: ["RALPH LAUREN"],
        },
        {
          displayName: "Ruggers",
          value: "Ruggers",
          legalBrandNames: ["Ruggers"],
        },
        {
          displayName: "SHISEIDO",
          value: "SHISEIDO",
          legalBrandNames: ["SHISEIDO"],
        },
        {
          displayName: "SUGR",
          value: "SUGR",
          legalBrandNames: ["SUGR"],
        },
        {
          displayName: "Sephora Collection",
          value: "Sephora Collection",
          legalBrandNames: ["Sephora Collection"],
        },
        {
          displayName: "Smashbox",
          value: "Smashbox",
          legalBrandNames: ["Smashbox"],
        },
        {
          displayName: "Soch",
          value: "Soch",
          legalBrandNames: ["Soch"],
        },
        {
          displayName: "Test",
          value: "Test",
          legalBrandNames: ["Test"],
        },
        {
          displayName: "The Children's Place",
          value: "The Children's Place",
          legalBrandNames: ["The Children's Place"],
        },
        {
          displayName: "True Blue",
          value: "True Blue",
          legalBrandNames: ["True Blue"],
        },
        {
          displayName: "U.S. Polo Assn.",
          value: "U.S. Polo Assn.",
          legalBrandNames: ["U.S. Polo Assn."],
        },
        {
          displayName: "U.S. Polo Assn. Denim Co.",
          value: "U.S. Polo Assn. Denim Co.",
          legalBrandNames: ["U.S. Polo Assn. Denim Co."],
        },
        {
          displayName: "U.S. Polo Assn. Kids",
          value: "U.S. Polo Assn. Kids",
          legalBrandNames: ["U.S. Polo Assn. Kids"],
        },
        {
          displayName: "U.S. Polo Assn. Women",
          value: "U.S. Polo Assn. Women",
          legalBrandNames: ["U.S. Polo Assn. Women"],
        },
        {
          displayName: "VALENTINO",
          value: "VALENTINO",
          legalBrandNames: ["VALENTINO"],
        },
        {
          displayName: "Yves Saint Laurent",
          value: "Yves Saint Laurent",
          legalBrandNames: ["Yves Saint Laurent"],
        },
        {
          displayName: "ZIRH",
          value: "ZIRH",
          legalBrandNames: ["ZIRH"],
        },
        {
          displayName: "benefit",
          value: "benefit",
          legalBrandNames: ["benefit"],
        },
        {
          displayName: "boscia",
          value: "boscia",
          legalBrandNames: ["boscia"],
        },
        {
          displayName: "dunhill",
          value: "dunhill",
          legalBrandNames: ["dunhill"],
        },
        {
          displayName: "roberto cavalli",
          value: "roberto cavalli",
          legalBrandNames: ["roberto cavalli"],
        },
        {
          displayName: "stila",
          value: "stila",
          legalBrandNames: ["stila"],
        },
        {
          displayName: "#stila",
          value: "#stila",
          legalBrandNames: ["#stila"],
        },
      ],
    },
    {
      filterType: "delivery_time",
      displayOrder: 5,
      displayName: "Delivery time",
      displayType: "custom",
      list: [
        {
          displayName: "Today",
          value: "today",
        },
        {
          displayName: "Tomorrow",
          value: "tomorrow",
        },
        {
          displayName: "In a week",
          value: "one_week",
        },
      ],
    },
  ],
};
const filterApiResponceWithoutBrand = {
  status: true,
  statusCode: 200,
  data: [
    {
      filterType: "Color",
      displayOrder: 1,
      displayName: "Color",
      displayType: "color",
      list: [
        {
          colorCode: "#000000",
          displayName: "Black",
          value: "Black",
        },
        {
          colorCode: "#0000CC",
          displayName: "Blue",
          value: "Blue",
        },
        {
          colorCode: "#7E3517",
          displayName: "Brown",
          value: "Brown",
        },
        {
          colorCode: "#FFEBCD",
          displayName: "Beige",
          value: "Beige",
        },
        {
          colorCode: "#FFD700",
          displayName: "Gold",
          value: "Gold",
        },
        {
          colorCode: "#008000",
          displayName: "Green",
          value: "Green",
        },
        {
          colorCode: "#808080",
          displayName: "Grey",
          value: "Grey",
        },
        {
          colorCode: "",
          displayName: "Multi-colour",
          value: "Multi-colour",
        },
        {
          colorCode: "#FFA500",
          displayName: "Orange",
          value: "Orange",
        },
        {
          colorCode: "#FF69B4",
          displayName: "Pink",
          value: "Pink",
        },
        {
          colorCode: "#9370DB",
          displayName: "Purple",
          value: "Purple",
        },
        {
          colorCode: "#FF0000",
          displayName: "Red",
          value: "Red",
        },
        {
          colorCode: "#C0C0C0",
          displayName: "Silver",
          value: "Silver",
        },
        {
          colorCode: "#FFFFFF",
          displayName: "White",
          value: "White",
        },
        {
          displayName: "No colour",
          value: "No colour",
        },
        {
          colorCode: "#FFFF00",
          displayName: "Yellow",
          value: "Yellow",
        },
        {
          colorCode: "",
          displayName: "Assorted",
          value: "Assorted",
        },
      ],
    },
    {
      filterType: "Price",
      displayOrder: 2,
      displayName: "Price",
      displayType: "minMaxRange",
      list: [
        {
          min: 0,
          max: 499,
        },
        {
          min: 500,
          max: 999,
        },
        {
          min: 1000,
          max: 1499,
        },
        {
          min: 1500,
          max: 1999,
        },
        {
          min: 2000,
          max: 0,
        },
      ],
    },
    {
      filterType: "Occasion",
      displayOrder: 3,
      displayName: "Occasion",
      displayType: "default",
      list: [
        {
          displayName: "Weekend",
          value: "Weekend",
          subOccasions: ["Casual"],
        },
        {
          displayName: "Work",
          value: "Work",
          subOccasions: ["Work", "Smart casual"],
        },
        {
          displayName: "Party",
          value: "Party",
          subOccasions: ["Party"],
        },
        {
          displayName: "Gym",
          value: "Gym",
          subOccasions: ["Gymming", "Yoga", "Sport", "Running", "Training"],
        },
        {
          displayName: "Outdoor",
          value: "Outdoor",
          subOccasions: ["Outdoors", "Outdoor"],
        },
      ],
    },
    {
      filterType: "delivery_time",
      displayOrder: 5,
      displayName: "Delivery time",
      displayType: "custom",
      list: [
        {
          displayName: "Today",
          value: "today",
        },
        {
          displayName: "Tomorrow",
          value: "tomorrow",
        },
        {
          displayName: "In a week",
          value: "one_week",
        },
      ],
    },
  ],
};
const test = "";

export { filterApiResponce, test, filterApiResponceWithoutBrand };



// WEBPACK FOOTER //
// ./src/stores/SearchBarStore/__test__/mocks.js